import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { myPageService } from 'shared/src/api';

export const usePocList = () => {
  return useSuspenseQuery({
    queryKey: queryKey.pocList(),
    queryFn: myPageService.getPocList,
  });
};
